import LTR from "@brand-icons/ploom/placeholder/placeholder-ltr.svg";
import RTL from "@brand-icons/ploom/placeholder/placeholder-rtl.svg";

import { iconFactory } from "../iconFactory";

export const PlaceholderIcon = iconFactory("PlaceholderIcon", LTR, RTL);
